import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useCopyToClipboard } from "react-use";
import { IconTransition } from "../IconTransition/IconTransition";
import FAIcon from "../FAIcon/FAIcon";
const DEFAULT_RENDERER = ({ text, icon, buttonProps, }) => {
    return (_jsxs("div", { className: "card rounded border bg-gray d-flex flex-row flex-nowrap justify-content-between", children: [_jsx("span", { className: "custom-scrollbar p-2", style: {
                    overflowX: "auto",
                    userSelect: "all",
                    whiteSpace: "nowrap",
                    fontFamily: "monospace",
                }, children: text }), _jsx("button", Object.assign({ className: "btn bg-gray flex-shrink-1 p-0" }, buttonProps, { children: icon }))] }));
};
const CopiableText = ({ text, children, }) => {
    const [copyToClipboardState, copyToClipboard] = useCopyToClipboard();
    const [triedToCopy, setTriedToCopy] = React.useState(false);
    const buttonRef = React.useRef(null);
    React.useLayoutEffect(() => {
        if (buttonRef.current) {
            if (triedToCopy) {
                $(buttonRef.current).tooltip("update").tooltip("show");
            }
            else {
                $(buttonRef.current).tooltip("hide");
            }
        }
    }, [triedToCopy]);
    let copyTitle = "Copy to clipboard";
    if (copyToClipboardState.error) {
        copyTitle = "Error copying to clipboard.";
    }
    else if (triedToCopy) {
        copyTitle = "Copied!";
    }
    const handleCopy = () => {
        copyToClipboard(text);
        setTriedToCopy(true);
        setTimeout(() => {
            setTriedToCopy(false);
        }, 1000);
    };
    const icon = (_jsx(IconTransition, { from: _jsx(FAIcon, { icon: "copy", fixedWidth: true }), to: copyToClipboardState.error ? (_jsx(FAIcon, { icon: "times", className: "text-danger", fixedWidth: true })) : (_jsx(FAIcon, { icon: "check", className: "text-success", fixedWidth: true })), transition: triedToCopy }));
    const buttonProps = {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        title: copyTitle,
        "data-original-title": copyTitle,
        onClick: handleCopy,
        buttonRef,
    };
    if (children) {
        return _jsx(_Fragment, { children: children({ icon, buttonProps }) });
    }
    return DEFAULT_RENDERER({ text, icon, buttonProps });
};
export default CopiableText;
